import { useState } from 'react';
import {
  Alert,
  Anchor,
  Button,
  Container,
  Paper,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { IconInfoCircle, IconMailFast } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { authApi } from '../../shared/api/auth';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await authApi.requestPasswordReset(email);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось отправить');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container size="xs" py="xl">
      <Title order={2} ta="center" mb="md">
        Восстановление пароля
      </Title>
      <Paper withBorder shadow="sm" p="lg" radius="md">
        {done ? (
          <Stack>
            <Alert color="green" icon={<IconMailFast size={20} />} title="Письмо отправлено">
              Если такой email зарегистрирован в системе, на него отправлена ссылка
              для сброса пароля. Проверьте входящие (и папку «Спам»).
            </Alert>
            <Text size="sm" c="dimmed">
              Ссылка действительна 1 час.
            </Text>
            <Anchor component={Link} to="/login" ta="center">
              Вернуться к входу
            </Anchor>
          </Stack>
        ) : (
          <form onSubmit={onSubmit}>
            <Stack>
              <Text size="sm" c="dimmed">
                Введите email, под которым зарегистрированы. Мы отправим вам ссылку
                на установку нового пароля.
              </Text>
              <TextInput
                label="Email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.currentTarget.value)}
                autoComplete="email"
              />
              {error && (
                <Alert color="red" icon={<IconInfoCircle size={16} />}>
                  {error}
                </Alert>
              )}
              <Button type="submit" loading={submitting} fullWidth>
                Отправить ссылку
              </Button>
              <Text size="sm" ta="center">
                Вспомнили пароль?{' '}
                <Anchor component={Link} to="/login">
                  Войти
                </Anchor>
              </Text>
            </Stack>
          </form>
        )}
      </Paper>
    </Container>
  );
}
